import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { AppConfig } from '../../app.config';
import { OfrAnnualReportStatus } from '../utility/constants';
import { BaseService } from './baseService';
import { ReportDetail } from './annualReportService';
import { AppInsightService } from './app-insight.service';

@Injectable()
export class OfrAnnualReportService extends BaseService{
    private controllerName:string = '/ofrannualreport';

    constructor(protected http: HttpClient, protected config: AppConfig, protected appInsights: AppInsightService) {
        super(http, config, appInsights);
    }

    public getAnnualReport(year: number, jurisdiction: string): Promise<OfrAnnualReport> {
        return this.httpget<OfrAnnualReport>(`${this.controllerName}/${year}/${jurisdiction}`);
    }

    public submitAnnualReport(annualreport: OfrAnnualReport): Promise<OfrAnnualReport> {       
        return this.httppost<OfrAnnualReport>(`${this.controllerName}/submit`, annualreport);
    }

    public saveAnnualReport(annualreport: OfrAnnualReport): Promise<OfrAnnualReport> {       
        return this.httppost<OfrAnnualReport>(this.controllerName, annualreport);
    }

    public createAnnualReport(year: number, jurisdiction: string): Promise<OfrAnnualReport> {
        return this.httppost<OfrAnnualReport>(`${this.controllerName}/create/${year}/${jurisdiction}`, null);
    }

    public uploadAnnualReportFile(file: any, annualreport:OfrAnnualReport, reportType:string): Promise<OfrAnnualReport> {
        let formData: FormData = new FormData();
            formData.append('file', file, file.name);
            formData.append('annualReport', JSON.stringify(annualreport));
        
        return this.httppost<OfrAnnualReport>(`${this.controllerName}/upload/${reportType}`, formData);
    }

    public downloadAnnualReportFile(year:string, jurisdiction:string, reportType:string): Promise<any> {
        return this.httpgetblob<any>(`${this.controllerName}/download/${year}/${jurisdiction}/${reportType}`);
    }

    public deleteAnnualReportFile(year:string, jurisdiction:string, reportType:string): Promise<OfrAnnualReport> {       
        return this.httppost<OfrAnnualReport>(`${this.controllerName}/delete/${year}/${jurisdiction}/${reportType}`, null);
    }
}

export class OfrAnnualReport{
    public id:string;
    public Year:number;
    public Jurisdiction:string;
    public TeamSummary:string;
    public TotalMeetingsHeld:number;
    public CasesSummary:string;
    public TeamMembers:string;
    public TeamLeadership:string;
    public Status:OfrAnnualReportStatus;
    public CaseReportDataGroups:Array<CaseReportDataGroup>;
    public ExternalRecommendations:Array<Recommendation>;
    public TeamRecommendations:Array<Recommendation>;
    public ReportDetails:Array<ReportDetail>;
}

export class Recommendation {
    public Id:number;
    public MainGoal:string;
    public ActionSteps:string;
    public TargetAudience:string;
    public SupportingEvidence:string;
    public PartnersAndStakeholders:string;
}

export class CaseReportDataGroup {
    public Category:string;
    public CaseReportData:Array<CaseReportData>;
}

export class CaseReportData {
    public Field:string;
    public FataOverdoses:number;
    public NonFatalOverdoses:number;
}